import InputSingleline from 'app/shared-components/InputSingleline'
import useEnumValues from 'app/hooks/useEnumValues'

import {
    AttitudeToSkyCell as AttitudeToSkyCellEnum,
} from 'app/enums/label.enums'

import MAP_COLOR from './attitudeToSkyCellColorMap.utils'
import useStyles from './AttitudeToSkyCell.style'

const AttitudeToSkyCell = ({
    value,
    title,
    disabled,
}: Readonly<{
    value: AttitudeToSkyCellEnum,
    title: string,
    disabled: boolean
}>) => {
    const {
        classes,
    } = useStyles()

    const allowedValues = useEnumValues()(AttitudeToSkyCellEnum)

    return (
        <InputSingleline
            value={allowedValues[value]}
            title={title}
            classNames={{
                text: classes[MAP_COLOR[value]],
            }}
            disabled={disabled}
        />
    )
}

export default AttitudeToSkyCell
